import { useCallback, useEffect, useState } from 'react';
import apiService from '../services/apiService.ts';

export const useManagers = (tenantId: string, enabled = true) => {
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    if (!enabled) {
      return;
    }
    if (!tenantId) return;
    setLoading(true);
    setError(null);
    try {
      const data = await apiService.getManagers(tenantId);
      setRows(data);
    } catch (err: any) {
      setRows([]);
      setError(err?.response?.data?.message || err?.message || 'Unable to load managers');
    } finally {
      setLoading(false);
    }
  }, [enabled, tenantId]);

  useEffect(() => {
    if (!enabled) {
      return;
    }
    fetchData();
  }, [enabled, fetchData]);

  return { rows, loading, error, refetch: fetchData };
};
